import { gql } from '@apollo/client';

export const GET_ALLOW_AD_HOC_REPORTING = gql`
  query GetAllowAdHocReporting {
    vm {
      configItem(key: "allow-ad-hoc-reporting") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ALLOW_LIMITED_AD_HOC_REPORTING = gql`
  query GetAllowLimitedAdHocReporting {
    vm {
      configItem(key: "allow-limited-ad-hoc-reporting") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_AD_HOC_REPORTING_RULES = gql`
  query GetAdHocReportingRules($isActive: Boolean) {
    vm {
      adHocReportingRules(isActive: $isActive) {
        adHocReportingRuleId
        name
        description
        isActive
        matchType
        programs {
          programId
          name
        }
        activities {
          activityId
          name
        }
        roles {
          activityRoleId
          name
        }
        permissionLevels
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_AD_HOC_REPORTING_RULE = gql`
  query GetAdHocReportingRule($ruleId: String!) {
    vm {
      adHocReportingRule(ruleId: $ruleId) {
        adHocReportingRuleId
        name
        description
        isActive
        matchType
        programs {
          programId
          name
        }
        activities {
          activityId
          name
        }
        roles {
          activityRoleId
          name
        }
        permissionLevels
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_PROGRAMS_FOR_AD_HOC = gql`
  query GetProgramsForAdHoc {
    vm {
      programs {
        programId
        name
        dateSuspended
      }
    }
  }
`;

export const GET_ACTIVITIES_FOR_AD_HOC = gql`
  query GetActivitiesForAdHoc {
    vm {
      programs {
        programId
        activities(includeInactiveActivities: false) {
          activityId
          name
          isSuspended
        }
      }
    }
  }
`;

export const GET_ACTIVITY_ROLES_FOR_AD_HOC = gql`
  query GetActivityRolesForAdHoc {
    vm {
      activityRoles {
        activityRoleId
        name
      }
    }
  }
`;